import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'
import _imports_1 from '@/assets/imgcaptions/icon_xinjianwenjianjia.svg'
import _imports_2 from '@/assets/imgcaptions/icon_tupianmoshi.svg'
import _imports_3 from '@/assets/imgcaptions/icon_liebiaomoshi.svg'
import _imports_4 from '@/assets/imgcaptions/icon_suoxiao.svg'
import _imports_5 from '@/assets/imgcaptions/icon_fangda.svg'


const _hoisted_1 = { class: "proListBox" }
const _hoisted_2 = { class: "proListStyle" }
const _hoisted_3 = { class: "proListTop" }
const _hoisted_4 = { class: "topRout" }
const _hoisted_5 = { class: "proListTitle" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "proListBtm" }
const _hoisted_8 = { class: "proListBtmOperate" }
const _hoisted_9 = { class: "operateLeft" }
const _hoisted_10 = { class: "operateSearch" }
const _hoisted_11 = { class: "addFolder" }
const _hoisted_12 = { class: "addFolderBoxTitle" }
const _hoisted_13 = { class: "addFolderBoxName" }
const _hoisted_14 = { class: "addFolderBoxNameInput" }
const _hoisted_15 = { class: "addFolderBoxBtn" }
const _hoisted_16 = { class: "btnBox" }
const _hoisted_17 = { class: "routIndexStyle" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "operateRight" }
const _hoisted_21 = { class: "scaleBox" }
const _hoisted_22 = { class: "scaleBoxInner" }
const _hoisted_23 = { class: "arrangeBox" }

import { ref,onMounted,getCurrentInstance ,watch} from 'vue'
import {
    Search,
    ArrowUp,
    View,
    Delete,
    Close,
} from "@element-plus/icons-vue";
// 头部下拉列表
import type { CheckboxValueType } from 'element-plus'
// 引入路由模块
import routerBox from "@/components/common/routerBox.vue"
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue"
// 引入排列组合块形模块 
import arrangePiece from "./arrangePiece.vue"
import arrangeStrip from "./arrangeStrip.vue"
// 引入滑块组件
import slider from '@/components/common/slider'
// 引入下拉框
import menuPage from "@/components/common/menuPage.vue";
import selectBox from "./selectBox.vue"
// 引入页面图标
import { applicationDetail } from "@/views/captions/icon.ts";
// 接口
import newCaptionApi from "@/api/newCaption/index.ts";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { useRouter ,useRoute} from "vue-router";
import { useChatStore } from "@/store/chatStore";
import VimConfig from "@/config/VimConfig";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import { nextTick } from 'vue';
import { useUploadStore } from "@/store/uploadRate";

export default /*@__PURE__*/_defineComponent({
  __name: 'projectList',
  setup(__props) {

let { proxy } = getCurrentInstance()

const router = useRouter();
const route=useRoute()
const menuShow=ref(false)
const chatStore = useChatStore();
const token = Auth.getToken();
const uploadStore = useUploadStore();
// watch(uploadStore.uploadTasks, (n, o) => {
//     console.log('检测上传进度')
//     console.log(n)
//     getListCaption()
// })
watch(route, (to, from) => {
    // console.log('列表页')
    // console.log(to)
    cities.value=JSON.parse(localStorage.getItem('projectoften'))||[]
    parentId.value=0
    routIndex.value=[{
        parentId:'0',
        name:''
    }]
    getListCaption()
    folderList()
})
onMounted(() => {
  document.addEventListener("click", (event) => {
    console.log(event);
    closeAll();
  });
});
const selectRef=ref()
const mainBoxRef=ref()
const closeAll = () => {
//   routerBoxref.value.closes();
  mainBoxRef.value?.closes();
  selectRef.value?.closes();
//   if(mainBoxRef.value!=undefined || mainBoxRef.value!=null||mainBoxRef.value.closes()!=undefined){
//         mainBoxRef.value.closes();
//     }
//     if(selectRef.value!=undefined || selectRef.value!=null||selectRef.value.closes()!=undefined){
//         selectRef.value.closes();
//     }
  addFolderShow.value=false
};
onMounted(()=>{
  let ips=''
  let wsProtocol=''
  if (Auth.getIp().indexOf("ai.123vp.com") > -1) {
    ips="ai.123vp.com"
    wsProtocol='wss'
  } else if (Auth.getIp().indexOf("14.242.3.137") > -1) {
    ips="114.242.3.137"
    wsProtocol='ws'
  }else{
    ips=Auth.getIp()
    wsProtocol='ws'
  }
//   console.log(VimConfig)
  //初始化websocket
  chatStore.reset();
  proxy.$ws.init(
    wsProtocol +
    "://" +
    ips +
    ":" +
    VimConfig.wsPort +
    "?token=" +
    Auth.getToken()
  );
})



onMounted(()=>{
    cities.value=JSON.parse(localStorage.getItem('projectoften'))||[]
    console.log(cities.value)
    })
    const changeSelect=(e)=>{
        console.log('changeSelect')
        console.log(e)
        router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: e } })
    }

//    查看文件夹数据
const routIndex=ref([
    {
        parentId:'0',
        name:''
    }
])
const openFiledData=(data:any)=>{
    
    const fileData=JSON.parse(data)
    parentId.value=fileData.id
    routIndex.value.push({
        parentId:fileData.id,
        name:fileData.folderName
    })
    
    newCaptionApi.getList(searchKey.value,pageNum.value,pageSize.value,fileData.id).then((res)=>{
        console.log(res)
        if(res.code==200){
            listCaption.value=res.rows
        }
    })
}
// 重新识别
const runDataRun=(data:any)=>{
    console.log(data)
    newCaptionApi.reRunAi(data).then((res)=>{
       console.log(res)
    })
}
// 删除
const delCaption=(data:any)=>{
    let delThis=cities.value.findIndex(item=>item.subtitleId==data[0].subtitleId)
   
    if(data[0].type==0){
        console.log('文件')
        newCaptionApi.delText(data[0].subtitleId).then((res)=>{
            console.log(res)
            listCaption.value.splice(data[1],1)
            if(delThis>=0){
                cities.value.splice(delThis,1)
                localStorage.setItem('projectoften', JSON.stringify(cities.value))
            }
        })
    }else {
        console.log('文件夹')
        
        newCaptionApi.delFolder(data[0].id).then((res)=>{
            console.log(res)
            listCaption.value.splice(data[1],1)
        })
    }
}
// 重命名
const reNameFun=(data:any)=>{
    console.log(data)
    if(data[0].type==0){
        console.log('文件')
       
        let parentId=data[0].parentId || 0
        newCaptionApi.putOne(data[0].subtitleId,parentId,data[0].title).then((res)=>{
            console.log(res)
        })
    }else {
        console.log('文件夹')
       
        let parentId=data[0].parentId || 0
        newCaptionApi.putFolderOne(data[0].id,parentId,data[0].folderName).then((res)=>{
            console.log(res)
        })
    }
}
// 切换显示类型 默认为块
const arrangeType=ref(true)

const value = ref<CheckboxValueType[]>([])
const optionName = ref('')
const cities = ref([])
// 切换展示模式
const changeType=(type:string)=>{
    if(type=='piece'){
        arrangeType.value=false
    }else{
        arrangeType.value=true
    }
    

}
// 滑块返回
const multiple=ref(0)
const indexrateData = (num: number) => {
    console.log(num)
    multiple.value=num
}
// 获取字幕列表
onMounted(()=>{
    getListCaption()
    folderList()
})
const searchKey=ref('')
const listCaption=ref([])
const pageNum=ref(1)
const pageSize=ref(500)
const folderId=ref(0)


const strip=ref()
const piece=ref()
onMounted(() => {
   proxy.$ws.onmessageCaption = (message: any) => {
    console.log(message)
    if(message.subtitleStatus==11 || message.subtitleStatus==12 || message.subtitleStatus==10||message.subtitleStatus==13){
        return;
    }
    
    // subtitleStatus=2时重新拉取列表
    if(message.subtitleStatus==2||message.subtitleStatus==3||message.subtitleStatus==100){
        getListCaption()
    }
    // if(message.subtitleStatus==3){
    //     getListCaption()
    // }
    nextTick(()=>{
        if(arrangeType.value){
        strip.value.reState(message.subtitleId,message.subtitleStatus)
            // 
        }else{
            piece.value.reStatepice(message.subtitleId,message.subtitleStatus)
        }
    })
        
   }
})
// 打开
const addFolderShow=ref(false)
const openaddFolder=()=>{
    addFolderShow.value=!addFolderShow.value
    folderName.value=''
}
// 新建文件夹
const folderName=ref('')
const parentId=ref(0)
const addFolderFun=()=>{
    const haveName=listCaption.value.findIndex(item=>(item.type==1 && item.folderName==folderName.value))
    if(haveName>=0){
        ElMessage.warning("文件夹名称重复!")
        return
    }
    if(folderName.value.length>100){
        ElMessage.warning("文件夹名称不能超过100字符!")
        return
    }
    newCaptionApi.addFolder(folderName.value,parentId.value).then((res)=>{
        console.log(res)
        if(res.code==200){
            addFolderShow.value=false
            getListCaption()
            folderList()
        }
    })
}
//新项目
const newProject=()=>{
    router.push("/index/aiApply/project")
    localStorage.setItem('captionTree',JSON.stringify(routIndex.value))
}
// 文件夹
const treeList=ref([{
    id: '0',
    label: '根目录',
    children: [],
}])
const routStr=ref('')
const folderList = () => {
    newCaptionApi.getFolderList().then((res) => {

        let resData = JSON.stringify(res.data).replaceAll("folderName", "label")
        treeList.value[0].children = (JSON.parse(resData))
        console.log(resData)
        // console.log(treeList.value)
    })
}


// 跳转查询对应文件
const toThisFolder=(item:any,index:number)=>{
    console.log('跳转查询对应文件')
    console.log(item)
    routIndex.value.splice((index+1),(routIndex.value.length-1))
    pageNum.value=1
    parentId.value=item.parentId
    searchKey.value=""
    getListCaption()
}
const getListCaption=()=>{
    newCaptionApi.getList(searchKey.value,pageNum.value,pageSize.value,parentId.value).then((res)=>{
        console.log(res)
        if(res.code==200){
            listCaption.value=res.rows
           
        }
    })
}



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "logoImg",
            onMousemove: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(applicationDetail).caption.name) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(applicationDetail).caption.version), 1)
          ]),
          _createVNode(selectBox, {
            ref_key: "selectRef",
            ref: selectRef,
            class: "selecTostyle",
            newShow: true,
            allShow: false,
            onChangeSelect: changeSelect
          }, null, 512)
        ]),
        _createVNode(mainBox, {
          class: "topMain",
          ref_key: "mainBoxRef",
          ref: mainBoxRef,
          onCloseAll: closeAll
        }, null, 512),
        _withDirectives(_createVNode(menuPage, {
          class: "menuPageStyle",
          onClosemenu: _cache[1] || (_cache[1] = ($event: any) => (menuShow.value=false)),
          onOpenmenu: _cache[2] || (_cache[2] = ($event: any) => (menuShow.value=true)),
          nameInfo: _unref(applicationDetail).caption
        }, null, 8, ["nameInfo"]), [
          [_vShow, menuShow.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "搜索",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchKey).value = $event))
              }, null, 512), [
                [_vModelText, searchKey.value]
              ]),
              _createElementVNode("span", null, [
                _createVNode(_component_el_icon, {
                  onClick: _withModifiers(getListCaption, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"width":"12rem"},
              size: "small",
              onClick: newProject
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("新建项目")
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_tooltip, {
                content: "新建文件夹",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "",
                    onClick: _withModifiers(openaddFolder, ["stop"])
                  })
                ]),
                _: 1
              }),
              (addFolderShow.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "addFolderBox",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "新建项目文件夹", -1)),
                      _createElementVNode("span", {
                        class: "closeBtn",
                        onClick: _withModifiers(openaddFolder, ["stop"])
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Close))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "addFolderBoxNameTitle" }, "文件夹名称", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "请输入文件夹名称",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((folderName).value = $event))
                        }, null, 512), [
                          [_vModelText, folderName.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", {
                          class: "btnOk",
                          onClick: _withModifiers(addFolderFun, ["stop"])
                        }, "确定")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routIndex.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("span", {
                    onClick: _withModifiers(($event: any) => (toThisFolder(item,index)), ["stop"])
                  }, _toDisplayString(item.name==''?'根目录':item.name), 9, _hoisted_18),
                  _cache[13] || (_cache[13] = _createTextVNode()),
                  (index!=(routIndex.value.length-1))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " / "))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "arrangeBtn",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (changeType('piece')), ["stop"])),
              style: _normalizeStyle(!arrangeType.value?{background: 'rgba(255,255,255,0.05)'}:'')
            }, [
              _createVNode(_component_el_tooltip, {
                content: "块状排列",
                placement: "bottom"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ], 4),
            _createElementVNode("div", {
              class: "arrangeBtn",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (changeType('strip')), ["stop"])),
              style: _normalizeStyle(arrangeType.value?{background: 'rgba(255,255,255,0.05)'}:'')
            }, [
              _createVNode(_component_el_tooltip, {
                content: "列表排列",
                placement: "bottom"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ], 4),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_tooltip, {
                content: "缩小",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "",
                    class: "scaleBoxSmall",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (multiple.value--), ["stop"]))
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(slider), {
                  num: multiple.value,
                  max: 100,
                  onUpdataNum: indexrateData
                }, null, 8, ["num"])
              ]),
              _createVNode(_component_el_tooltip, {
                content: "放大",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_5,
                    alt: "",
                    class: "scaleBoxLarge",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (multiple.value++), ["stop"]))
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (!arrangeType.value )
            ? (_openBlock(), _createBlock(arrangePiece, {
                key: 0,
                class: "commonStyle",
                size: multiple.value,
                list: listCaption.value,
                justUse: cities.value,
                onDel: delCaption,
                onReName: reNameFun,
                onShowopenFiled: openFiledData,
                onRunDataRun: runDataRun,
                ref_key: "piece",
                ref: piece,
                treeList: treeList.value,
                onReCatalog: getListCaption
              }, null, 8, ["size", "list", "justUse", "treeList"]))
            : _createCommentVNode("", true),
          (arrangeType.value )
            ? (_openBlock(), _createBlock(arrangeStrip, {
                key: 1,
                class: "commonStyle",
                size: multiple.value,
                list: listCaption.value,
                justUse: cities.value,
                onDel: delCaption,
                onReName: reNameFun,
                onShowopenFiled: openFiledData,
                onRunDataRun: runDataRun,
                ref_key: "strip",
                ref: strip,
                treeList: treeList.value,
                onReCatalog: getListCaption
              }, null, 8, ["size", "list", "justUse", "treeList"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})